import {  HttpResponse } from "@angular/common/http";

export class Reply {
  error: boolean;
  value: object;
	messages: string;
  question: boolean;

  public static fromJson(json: object): Reply {
    let reply = new Reply();
    reply.error = json["error"];
    reply.value = json["value"];
    reply.messages = json["messages"];
    reply.question = json["question"];
    return reply;
  }
}
